import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class KnBrSidebarService {
  menuOpen = false;
  menuOpen$: BehaviorSubject<boolean> = new BehaviorSubject(this.menuOpen);
  constructor() { }

  loadMenuState$(): Observable<boolean> {
    return this.menuOpen$.asObservable();
  }

  toggleMenuState() {
    this.menuOpen$.next(!this.menuOpen);
  }

  changeMenuState(menuState: boolean) {
    this.menuOpen$.next(menuState);
  }
}
